<template>
  <div class="m-pc-footer-new">
    <div class="g-footer-content-new">{{desc}}
    </div>
    <div class="g-footer-img-new">
      <img :src="imgUrl" alt="">
    </div>
  </div>
</template>

<script>
import { $subscriber } from "fire-wind-water";
export default {
  name: "Footer",
  data() {
    return {
      desc:'',
      imgUrl:'',

    };
  },
  created() {
    $subscriber.subscribe('footerInfo',data=>{
      this.desc = data.desc;
      const json = data.imgUrl || '';
      if(json){
        let mappingId = JSON.parse(json).mapId;
        console.log(mappingId);
        this.imgUrl = window.config.api.ungateway.contentUrl + "?mappingId=" + mappingId;
      }

    })
  },
};
</script>

<style scoped></style>
